var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('app-image',{attrs:{"url":"logo.png","is-local":"","alt":"Pinguinitos logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }